import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { mdiFacebook, mdiInstagram, mdiLinkedin } from "@mdi/js"
import Icon from "@mdi/react"
import { menuItems } from "../utils"
import "../style/Footer.scss"
import { getServices } from "../redux"

function Footer() {
  const services = useSelector(getServices)

  const menuItemsList = menuItems.map((item, index) => {
    let path = "/"
    if (item !== "Acasa") path += item.toLowerCase().split(" ").join("-")

    return (
      <Link className="footer__link" to={path} key={index}>
        {item}
      </Link>
    )
  })

  const servicesList = services.map(service => (
    <Link className="footer__link" to={service.id} key={service.id}>
      {service.title}
    </Link>
  ))

  const handleContact = ev => {
    ev.preventDefault()
    window.open("tel:+40747667827")
  }

  return (
    <div className="footer">
      <div className="footer__container">
        <Link to="/">
          <img
            className="footer__logo"
            src="https://firebasestorage.googleapis.com/v0/b/xposed-837fc.appspot.com/o/predefined%2FLogo_Footer_white.png?alt=media&token=7ea7663d-1c6e-4c71-943d-4414439ca0d7"
            alt="logo"
            loading="lazy"
          />
        </Link>
        <div className="footer__columns">
          <div className="footer__columns__item">
            <span>PAGINI</span>
            {menuItemsList}
          </div>
          <div className="footer__columns__item">
            <span>SERVICII</span>
            {servicesList}
          </div>
          <div className="footer__columns__item">
            <span>CONTACT</span>
            <button
              className="footer__button footer__link"
              onClick={handleContact}>
              +40 759 513 983
            </button>
            <Link className="footer__link" to="/contact#contactForm">
              contact@xposed.ro
            </Link>
          </div>
        </div>
      </div>
      <div className="footer__copyright">Xposed Agency © 2021</div>
      <div className="footer__bottom">
        <div className="footer__policies">
          <Link
            className="footer__link footer__policies__link"
            to="/politica-de-confidentialitate">
            POLITICA DE CONFIDENTIALITATE
          </Link>
        </div>
        <div className="footer__icons">
          <a
            className="footer__icons__icon"
            href="https://www.facebook.com/xposedromania/">
            <Icon path={mdiFacebook} size={1.2} color="#031e32" />
          </a>
          <a
            className="footer__icons__icon"
            href="https://www.linkedin.com/company/xposed-agency">
            <Icon path={mdiLinkedin} size={1.2} color="#031e32" />
          </a>
          <a
            className="footer__icons__icon"
            href="https://www.instagram.com/xposedagency/">
            <Icon path={mdiInstagram} size={1.2} color="#031e32" />
          </a>
        </div>
      </div>
    </div>
  )
}

export default Footer
